import * as ActionTypes from '../constants/ActionTypes'
import { postRequest_ } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function changeFields(fields){
  return {
    type: ActionTypes.SET_FIELDS,
    fields: fields
  }
}

export function errorForm(errors){
  return{
    type: ActionTypes.SET_ERROR_FORMS,
    errors: errors
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

const auth = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    dispatch(errorForm({}));
    postRequest_(data, "auth").then(
    (response) => {
      window.localStorage.setItem('token_codesii', response.data.token);
      if (data.check) {
        window.localStorage.setItem('email_codesii', data.email);
        window.localStorage.setItem('password_codesii', data.password);
      }else{
        localStorage.removeItem("email_codesii");
        localStorage.removeItem("password_codesii");
      }
      window.location.href = "/home";
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData('Credenciales incorrectas', 'toastMessage'));
        dispatch(setData(true, 'simpleToast'));
        setTimeout(function(){
          dispatch(setData(false, 'simpleToast'));
        }, 3000);
      }else if(err.response.status === 422){
        dispatch(errorForm(err.response.data));
      }else{
        dispatch(setData(true, 'errorServer'));
      }
    }
    );
  }
};

export default {
  changeFields,
  auth
}
